<script setup>
import { ref, computed } from 'vue'
import { storeToRefs } from 'pinia'
import { langUrl, getFilePrefix } from '@/helpers'
import { useLangStore } from '@/stores/app/lang'
import { useSlideshowStore } from '@/stores/gallery/slideshow'

const { lang } = storeToRefs(useLangStore())
const slideshowStore = useSlideshowStore()

// State -----------------------------------------

// Getters ---------------------------------------
const item = computed(() => slideshowStore.activedItem)

// Methods ---------------------------------------

// Events ----------------------------------------

// Main Setup ------------------------------------

// -----------------------------------------------
</script>

<template>
  <transition name="fade-lang">
    <div v-if="item" class="item-caption" :key="lang" :lang="lang">
      <transition name="fade-caption">
        <img :key="item" :src="langUrl(`/images/gallery/item-caption/th/d${getFilePrefix(item)}.png`)" />
      </transition>
    </div>
  </transition>
</template>

<style scoped>
/* ------------------------ */
.fade-caption-enter-active,
.fade-caption-leave-active {
  transition: opacity 0.4s ease;
}
.fade-caption-enter-from,
.fade-caption-leave-to {
  opacity: 0;
}

/* ------------------------ */
.item-caption {
  position: absolute;
}

.item-caption img {
  position: absolute;
  left: 0;
  top: 0;
}

/* ------------------------ */
</style>
